module.exports = __webpack_public_path__ + "img/phn.b40e1aca.png";